import { Vehicle } from "../../Interfaces/vehicle.type";
import getVehicleDataPush from "../getVehicleDataPush";

const downloadImagesDataPush = (vehicle: Vehicle) => {
  const vehicleDataPush = getVehicleDataPush(vehicle);

  //@ts-ignore
  if (window.digitalData) {
    //@ts-ignore
    return digitalData.push({
      event: {
        name: "click",
        category: "button",
        label: "image-all",
        action: "download",
        type: "zip",
      },
      ...vehicleDataPush,
    });
  }
};

export default downloadImagesDataPush;
